import React, {Component} from 'react'

import {Treemap, Pie} from "d3plus-react"; //https://www.npmjs.com/package/d3plus-react
import * as d3 from 'd3v4';
import {Typeahead} from 'react-bootstrap-typeahead';
import WidgetLoader from "./WidgetLoader"; //https://www.npmjs.com/package/react-bootstrap-typeahead



import {Row, Col, FormControl, Checkbox, Button} from "react-bootstrap";
import Datetime from "react-datetime";
//https://github.com/pushtell/react-bootstrap-date-picker#readme
import HttpClient from "../../utils/HttpClient/HttpClient";
import * as qs from "qs";
import history from "../../routes/History/history";
import Loader from "../elements/loader/Loader";
import DelayHelper from "../Helpers/DelayHelper";
import MaterialIcon from 'material-icons-react'
import TopWidgetComponent from "./TopWidgetComponent";

export default class TreeMapDelayWidget extends Component {

    data = [
        {id: "alpha", value: 29, color: "cyan"},
        {id: "beta",  value: 10, color: "green"}
    ];

    blue = ['#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#42A5F5', '#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1'].reverse();

    // blue = ['#4a148c', '#ff9100', '#7c43bd', '#ffc246', '#12005e', '#c56200'].reverse();
    // $primaryColor:#4a148c;
    // $primaryLightColor:#7c43bd;
    // $primaryDarkColor:#12005e;
    // $secondaryColor:#ff9100;
    // $secondaryLightColor:#ffc246;
    // $secondaryDarkColor:#c56200;
    httpClient;
    delayHelper;
    constructor(props){
        super(props);
        this.state = {
            selected: null,
            methods: null,
            checked: false,
            date: new Date().toISOString(),
        };
        this.httpClient = new HttpClient(true);
        this.delayHelper = new DelayHelper();
    }

    componentWillMount(){

        let methods = {
            groupBy: "ordinal",
            loadingHTML: "",
            data: this.data,
            sum: "qty",
            tooltipConfig: {
                body: this.toolTip,
                title: function(d) { return d.color; }
            },
            label: (d) => d.name,
            color: this.delayHelper.getDelayColor,
            size: d => d.value
        };

        // let colorDomain = this.data.map(function (d) { return d.id });
        // let rangeColor = d3.scaleOrdinal().domain(colorDomain).range(this.blue);
        this.httpClient.get(`oga/dashboard/widget/${this.props.id}`).then((response) => { this.setState({ checked: response.data }); })
            .catch((error) => {
                console.error("oga/dashboard/widget error", error);
            });

        this.httpClient.post("oga/treemap/delay", {})
            .then((response) => {

                console.dir(response);
                methods.data = response.data;
                this.setState( { methods: methods } );
            })
            .catch((error) => {
                console.error("oga/treemap/delay error", error);
                this.setState( { methods: null } );
            });



    }

    toolTip(d){
        // let table = '<table class="tooltip-table">';
        // table += '<tr><td class="title">Sales Unit:</td><td class="data">'+ d.sales + '</td></tr>';
        // table += '<tr><td class="title">Total $:</td><td class="data">'+ d.price + '</td></tr>';
        // table += '</table>';
        // return table;
        return "";
    }

    cb;
    render() {
        let loaded = this.state.methods != null;
        return (
            <div className="widget-container w-100">
                {
                    !loaded ? <Loader classes="widget-default-height" show={true}/> :
                        <div>
                            <Row className="widget-container-padding">
                                <Col md={12} className={"no-padding no-margin"}>
                                    <form>
                                        <TopWidgetComponent id={this.props.id}
                                                            label={this.props.name}
                                                            onSelectionChange={ (val, id) => this.props.onSelectionChange(val, id) }
                                                            isDashboard={this.props.isDashboard}/>
                                    </form>
                                </Col>
                                <Col md={12} className="widget-default-height no-padding no-margin">
                                    <Treemap config={this.state.methods} />
                                </Col>
                            </Row>
                        </div>
                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Widgets/TreeMapDelayWidget.jsx